export default "__VITE_ASSET__BQmmvTFf__"